export default __webpack_public_path__ + "static/media/set_2_Promo-1.49fb647f.svg";